import React from 'react';
import styles from '../../../styles/components/drag-and-drop/actions/AddAction.module.css';
import addIcon from '../../../assets/plus_circle_blue.svg';

export interface AddActionProps {
  onAdd: () => void;
}

const AddAction: React.FC<AddActionProps> = ({ onAdd }) => {
  return (
    <div className={styles.container}>
      <div className={styles.icon} onClick={onAdd}>
        <img src={addIcon} alt="add" />
      </div>
    </div>
  );
};

export default AddAction;
